// Browser-compatible Cloudinary configuration using Upload Widget
// This approach works in React applications without Node.js polyfills

// Cloudinary configuration
const CLOUDINARY_CONFIG = {
  cloud_name: process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || 'df9blra5f',
  upload_preset: 'ml_default', // You can create a custom upload preset in your Cloudinary dashboard
  folder: 'payment-receipts'
};

// Upload image to Cloudinary using the Upload Widget
export const uploadImageToCloudinary = (file) => {
  return new Promise((resolve, reject) => {
    // Create form data for upload
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', CLOUDINARY_CONFIG.upload_preset);
    formData.append('cloud_name', CLOUDINARY_CONFIG.cloud_name);
    formData.append('folder', CLOUDINARY_CONFIG.folder);

    // Upload to Cloudinary
    fetch(`https://api.cloudinary.com/v1_1/${CLOUDINARY_CONFIG.cloud_name}/image/upload`, {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      if (data.secure_url) {
        resolve({
          success: true,
          url: data.secure_url,
          publicId: data.public_id
        });
      } else {
        reject(new Error('Upload failed: ' + (data.error?.message || 'Unknown error')));
      }
    })
    .catch(error => {
      console.error('Cloudinary upload error:', error);
      reject(error);
    });
  });
};

// Validate file before upload
export const validateFile = (file) => {
  const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
  const maxSize = 10 * 1024 * 1024; // 10MB

  if (!allowedTypes.includes(file.type)) {
    return {
      valid: false,
      error: 'Please select an image file (JPG, PNG, or WebP)'
    };
  }

  if (file.size > maxSize) {
    return {
      valid: false,
      error: 'File size must be less than 10MB'
    };
  }

  return {
    valid: true,
    error: null
  };
};

// Delete image from Cloudinary (if needed)
export const deleteImageFromCloudinary = async (publicId) => {
  try {
    // Note: This requires server-side implementation for security
    // For now, we'll just return success as deletion is typically handled server-side
    console.log('Image deletion requested for:', publicId);
    return {
      success: true,
      message: 'Image deletion would be handled server-side'
    };
  } catch (error) {
    console.error('Cloudinary delete error:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

// Get Cloudinary configuration status
export const getCloudinaryConfigStatus = () => {
  const config = {
    cloud_name: process.env.REACT_APP_CLOUDINARY_CLOUD_NAME,
    upload_preset: CLOUDINARY_CONFIG.upload_preset
  };

  return {
    cloud_name: config.cloud_name ? '✅ Set' : '❌ Not set',
    upload_preset: config.upload_preset ? '✅ Set' : '❌ Not set',
    isConfigured: !!(config.cloud_name && config.upload_preset)
  };
};

// Test Cloudinary upload functionality
export const testCloudinaryUpload = async (testFile) => {
  try {
    console.log('🧪 Testing Cloudinary upload...');
    
    const validation = validateFile(testFile);
    if (!validation.valid) {
      return {
        success: false,
        error: validation.error
      };
    }

    const result = await uploadImageToCloudinary(testFile);
    console.log('✅ Upload test successful:', result);
    
    return {
      success: true,
      result
    };
  } catch (error) {
    console.error('❌ Upload test failed:', error);
    return {
      success: false,
      error: error.message
    };
  }
}; 